// Twig-native pages don't render #js-global-wait-mask (legacy chrome only),
// so guard the lookup. aria-busy on <body> is the unified signal both pipelines
// can rely on for "operation in flight".
export function show() {
  document.getElementById('js-global-wait-mask')?.classList.add('js_active');
  document.getElementById('js-body')?.setAttribute('aria-busy', 'true');
}

export function hide() {
  document.getElementById('js-global-wait-mask')?.classList.remove('js_active');
  document.getElementById('js-body')?.setAttribute('aria-busy', 'false');
}

// Expose the functions to the global scope for legacy scripts
// TODO remove this after migrating legacy scripts to modules
window.showLoadMask = show;
window.hideLoadMask = hide;
